module.exports = __webpack_public_path__ + "img/gmail2.41f99cf0.png";